import { NoteMessage } from '@/@types/messages/NoteMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class NoteService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public deleteNote(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/notes/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateNote(noteId: number, noteMessage: NoteMessage): Promise<void> {
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(noteMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/notes/${noteId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
